var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEye2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.5,
    height: 15.38,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Raggruppa 16",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Tracciato 5",
    d: "M19 7.628c0 1.453-4.16 5.187-8.75 5.187a9.2 9.2 0 0 1-1.911-.213l-1.226 1.224a11.122 11.122 0 0 0 3.137.489c4.949 0 10.25-3.925 10.25-6.687 0-1.315-1.209-2.891-3-4.185l-1.09 1.091c1.577 1.1 2.593 2.377 2.593 3.094",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Tracciato 6",
    d: "M1.5 7.628c0-1.453 4.16-5.187 8.75-5.187a9.212 9.212 0 0 1 1.983.23l1.223-1.222A11.178 11.178 0 0 0 10.25.941C5.301.941 0 4.866 0 7.628c0 1.328 1.232 2.922 3.055 4.222l1.09-1.09C2.537 9.647 1.5 8.353 1.5 7.628",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Tracciato 7",
    d: "M10.071 4.833 11.41 3.49a4.24 4.24 0 0 0-1.16-.175 4.318 4.318 0 0 0-4.313 4.312 4.248 4.248 0 0 0 .179 1.163l1.339-1.339a2.8 2.8 0 0 1 2.616-2.616",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Tracciato 8",
    d: "m10.528 10.412-1.371 1.371a4.256 4.256 0 0 0 5.247-5.248l-1.37 1.371a2.8 2.8 0 0 1-2.506 2.506",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Tracciato 9",
    d: "M17.196.62a.875.875 0 0 1 0 1.237L4.29 14.76a.875.875 0 0 1-1.237-1.237L15.958.619a.875.875 0 0 1 1.238 0Zm-1.061 1.06a.625.625 0 0 0 .884 0L4.114 14.584a.625.625 0 0 0-.884-.883L16.135.796a.625.625 0 0 0 0 .884Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye2);
export default __webpack_public_path__ + "static/media/eye2.8c7e38052f4f4f321cf65347149eeeab.svg";
export { ForwardRef as ReactComponent };